/**
 * To eliminate dead code, ensure you use
 * `new webpack.DefinePlugin({ __DEV__: !env.isProd })` in the webpack config.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const __DEV__ = process.env.NODE_ENV !== 'production';
